// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SectionMaterials_wrapper__1E6Uc","materials":"SectionMaterials_materials__33meb","materialCard":"SectionMaterials_materialCard__Nlvl_"};